import { PaymentOffsetInterface } from "../PaymentOffsetInterface";
import { PaymentOffset } from "../PaymentOffset";
import Translator from "../../../../../Translation/Translator";

class Plus2Day extends PaymentOffset implements PaymentOffsetInterface  {

  public static value: number = 2;

  public getName(): string {
    return Translator.trans("payment-offset-plus-2-day");
  }

}

export { Plus2Day }
